import {
  useEntitiesServiceEntitiesVehicleBrandsList,
  useEntitiesServiceEntitiesVehicleModelsListKey
} from '@insurance/api/queries'
import { EntitiesService, VehicleBrand } from '@insurance/api/requests'
import { InfiniteSelect } from '@shared/components'
import { useDebounce } from '@shared/hooks'
import { capitalize } from '@shared/utils'
import { SelectProps } from 'antd'
import { useEffect } from 'react'

type Props = {
  brand: string
  onBrandFound?: (brand: VehicleBrand) => void
} & SelectProps

export const EditVehicleModelSelect = ({
  brand,
  onBrandFound,
  ...props
}: Props) => {
  const debouncedBrand = useDebounce(brand)

  const { data: brandResponse } = useEntitiesServiceEntitiesVehicleBrandsList(
    { ids: debouncedBrand?.toUpperCase() },
    undefined,
    { enabled: !!debouncedBrand }
  )

  useEffect(() => {
    const foundBrand = brandResponse?.results[0]

    if (!foundBrand) return

    onBrandFound?.(foundBrand)
  }, [brandResponse])

  const foundBrandName = brandResponse?.results[0]?.name

  return (
    <InfiniteSelect
      apiCall={({ search, pageParam, pageSize }) =>
        EntitiesService.entitiesVehicleModelsList(
          foundBrandName,
          undefined,
          undefined,
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      queryKey={[
        useEntitiesServiceEntitiesVehicleModelsListKey,
        foundBrandName
      ]}
      getOption={({ name }) => ({ value: capitalize(name) })}
      {...props}
    />
  )
}
